import { createSlice } from "@reduxjs/toolkit";

interface ModalValueType {
  isOpen: boolean;
  id: number | null;
}

const initialState: ModalValueType = {
  isOpen: false,
  id: null,
};

export const messageActionSlice = createSlice({
  name: "messageActionSlice",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
      state.id = action.payload;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.id = null;
    },
  },
});

export const { openModal, closeModal } = messageActionSlice.actions;

export default messageActionSlice.reducer;
